import React from 'react'
import DropInVideoPlayer from '../DropInVideoPlayer/index'
import {
  BASIC_CONTROLS,
  BASIC_CONTROL_OPTIONS_VOLUME,
} from '../DropInVideoPlayer/DropInVideoPlayer'
import { createPlayerSrc } from '../../services/brightcove/index'
import {
  H1,
} from '../Heading/index'
import { HEADING_TYPES } from '../Heading/_Heading'

const Banner = ({
  title, speaker, dateText,
  media, location, promoText, promoTextMobile,
}) => (<div className="event-details-page-banner">
         {Number.isNaN(Number(media))
           ? (<div
        className="banner"
        style={{
          backgroundImage: `url(${media && media.split(',')[0]})`,
        }}
      >
        {promoText && (
          <div className="banner__promo hide-in-mobile">
            {promoText}
          </div>
        )}
        {promoTextMobile && (
          <div className="banner__promo hide-in-desktop">
            {promoTextMobile}
          </div>
        )}
        <div className="banner__overlay">
          <div className="banner__text-info">
            {speaker && (
              <div className="speaker">
                {speaker}
              </div>
            )}
            {title && (
              <H1 inverted as={[HEADING_TYPES.H1_MOBILE, HEADING_TYPES.H2_DESKTOP]} className="title">
                {title}
              </H1>
            )}
            {dateText && (
              <div className="dates">
                {dateText} &bull; {location}
              </div>
            )}
          </div>
        </div>
      </div>)
           : (
        <DropInVideoPlayer
          autoplay
          loop
          playsinline
          controls={{
            type: BASIC_CONTROLS,
            visibleControls: [BASIC_CONTROL_OPTIONS_VOLUME],
          }}
          mediaId={Number(media)}
          playerSrc={createPlayerSrc(1263232739001, media)}
        />
           )
    }
  </div>)

Banner.propTypes = {}

export default Banner
